export default __webpack_public_path__ + "static/media/lm.005.94a0ecde.png";